import { AuthService } from './AuthService';
import { SiteReportingService } from './SiteReportingService';
import { mockAuthService } from './AuthService/mockAuthService';
import { mockSiteReportingService } from './SiteReportingService/mockSiteReportingService';
import { mockPartnerService } from './PartnerService/mockPartnerService';
import { mockFulfillmentConfigService } from './FulfillmentConfigService/mockFulfillmentConfigService';
import { FulfillmentConfigService } from './FulfillmentConfigService';
import { PartnerService } from './PartnerService';
import getGatewayUri from './getGatewayUri';
import { ApiStatusService } from './ApiStatusService';
import mockApiStatusService from './ApiStatusService/mockApiStatusService';
import { FileService } from './FileService';
import { mockFileService } from './FileService/mockFileService';
import { TrackingService } from './TrackingService';
import { mockTrackingService } from './TrackingService/mockTrackingService';
import { SecurityService } from './SecurityService';
import { mockSecurityService } from './SecurityService/mockSecurityService';
import { CarrierService } from './CarrierService';
import { mockCarrierService } from './CarrierService/mockCarrierService';
import { ShiptimeService } from './ShiptimeService';
import { mockShiptimeService } from './ShiptimeService/mockShiptimeService';
import { LimitService } from './LimitService';
import { mockLimitService } from './LimitService/mockLimitService';
import { AssetService } from './AssetService';
import { PartnerConfigurationService } from './PartnerConfigurationService';
import { mockPartnerConfigurationService } from './PartnerConfigurationService/mockPartnerConfigurationService';
import RuleSetServiceV2 from './RuleSetServiceV2';
import RuleSetServiceV2Mock from './RuleSetServiceV2/RuleSetServiceV2Mock';
import { FP_FulfillmentContextService } from './FP_FulfillmentContextService';
import { mockFulfillmentContextService } from './FP_FulfillmentContextService/mockFulfillmentContextService';
import { ZipZoneService } from './ZipZoneService';
import { SimulationService } from './SimulationService';
import mockSimulationService from './SimulationService/mockSimulationService';
import { TimeInTransitService } from './TimeInTransitService';
import mockTimeInTransitService from './TimeInTransitService/mockTimeInTransitService';
import { ScheduleService } from './ScheduleService';
import { LedgerService } from './LedgerService';
import { mockLedgerService } from './LedgerService/mockLedgerService';
import { DatalakeService } from './DatalakeService';
import { AddressService } from './AddressService';
import { FulfillmentEngineService } from './FulfillmentEngineService';
import { UIOrchestrationService } from './UIOrchestrationService';
import { ImportExportService } from './ImportExportService';
import { QueryClient } from '@tanstack/react-query';

export interface Injections {
  queryClient: QueryClient;
  authService: AuthService;
  partnerService: PartnerService;
  siteReportingService: SiteReportingService;
  fulfillmentConfigService: FulfillmentConfigService;
  fulfillmentContextService: FP_FulfillmentContextService;
  apiStatusService: ApiStatusService;
  fileService: FileService;
  trackingService: TrackingService;
  securityService: SecurityService;
  carrierService: CarrierService;
  ruleService: RuleSetServiceV2;
  shiptimeService: ShiptimeService;
  limitService: LimitService;
  assetService: AssetService;
  partnerConfigurationService: PartnerConfigurationService;
  zipZoneService: ZipZoneService;
  simulationService: SimulationService;
  timeInTransitService: TimeInTransitService;
  scheduleService: ScheduleService;
  ledgerService: LedgerService;
  datalakeService: DatalakeService;
  addressService: AddressService;
  fulfillmentEngineService: FulfillmentEngineService;
  UIOrchestrationService: UIOrchestrationService;
  importExportService: ImportExportService;
}

export let injections: Injections = {} as Injections;
const gatewayURI = getGatewayUri();
/**
 * Injections control what concrete implementations are used
 * by the redux store to perform mutations and fetch data.
 */
if (gatewayURI) {
  injections = {
    queryClient: null!, // injected by App.tsx after QueryClientProvider is mounted
    partnerService: new PartnerService(),
    authService: new AuthService(),
    securityService: new SecurityService(),
    siteReportingService: new SiteReportingService(),
    fulfillmentConfigService: new FulfillmentConfigService(),
    fulfillmentContextService: new FP_FulfillmentContextService(),
    apiStatusService: new ApiStatusService(),
    fileService: new FileService(),
    trackingService: new TrackingService(),
    carrierService: new CarrierService(),
    ruleService: new RuleSetServiceV2(),
    shiptimeService: new ShiptimeService(),
    limitService: new LimitService(),
    assetService: new AssetService(),
    partnerConfigurationService: new PartnerConfigurationService(),
    zipZoneService: new ZipZoneService(),
    simulationService: new SimulationService(),
    timeInTransitService: new TimeInTransitService(),
    scheduleService: new ScheduleService(),
    ledgerService: new LedgerService(),
    datalakeService: new DatalakeService(),
    addressService: new AddressService(),
    fulfillmentEngineService: new FulfillmentEngineService(),
    UIOrchestrationService: new UIOrchestrationService(),
    importExportService: new ImportExportService(),
  };
} else {
  injections = {
    queryClient: new QueryClient(),
    partnerService: mockPartnerService,
    authService: mockAuthService,
    siteReportingService: mockSiteReportingService as unknown as SiteReportingService,
    fulfillmentConfigService: mockFulfillmentConfigService,
    fulfillmentContextService: mockFulfillmentContextService,
    apiStatusService: mockApiStatusService,
    fileService: mockFileService,
    trackingService: mockTrackingService,
    securityService: mockSecurityService,
    carrierService: mockCarrierService,
    ruleService: new RuleSetServiceV2Mock() as unknown as RuleSetServiceV2,
    shiptimeService: mockShiptimeService,
    limitService: mockLimitService,
    assetService: new AssetService(),
    partnerConfigurationService: mockPartnerConfigurationService,
    zipZoneService: new ZipZoneService(), // TODO: Add mock
    simulationService: mockSimulationService,
    timeInTransitService: mockTimeInTransitService,
    scheduleService: new ScheduleService(), //TODO: Add mock
    ledgerService: mockLedgerService,
    datalakeService: new DatalakeService(),
    addressService: new AddressService(), //TODO: Add mock
    fulfillmentEngineService: new FulfillmentEngineService(), //TODO: Add mock
    UIOrchestrationService: new UIOrchestrationService(),
    importExportService: new ImportExportService(),
  };
}
